import { deleteAppointment } from "../../api/appointmentService";

export const useDeleteAppointment = (successCallback) => {
    const remove = async (id) => {
        try {
            await deleteAppointment(id);
            successCallback();
        } catch (error) {
            console.error("Failed to delete appointment:", error);
            throw error;
        }
    };

    return { remove };
};